import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { HelmetProvider } from '@dr.pogodin/react-helmet';
import { WizardProvider } from '@/components/wizard/WizardContext';
import { AdminProvider } from '@/components/admin/AdminContext';
import { Toaster } from '@/components/ui/toaster';
import { OrganizationStructuredData } from '@/components/SEO';
import LandingPage from '@/pages/LandingPage';
import HomePage from '@/pages/HomePage';
import PlatformDetailPage from '@/pages/PlatformDetailPage';
import ComparisonPage from '@/pages/ComparisonPage';
import AdminPage from '@/pages/AdminPage';
import EducationPage from '@/pages/EducationPage';
import BlogPage from '@/pages/BlogPage';
import BlogPostPage from '@/pages/BlogPostPage';
import SharedResultsPage from '@/pages/SharedResultsPage';
import SuggestPage from '@/pages/SuggestPage';
import VendorInfoPage from '@/pages/VendorInfoPage';
import VendorAuthPage from '@/pages/VendorAuthPage';
import VendorDashboardPage from '@/pages/VendorDashboardPage';
import VendorEditPlatformPage from '@/pages/VendorEditPlatformPage';
import VendorPricingPage from '@/pages/VendorPricingPage';
import VendorTermsPage from '@/pages/VendorTermsPage';
import PrivacyPage from '@/pages/PrivacyPage';
import TermsPage from '@/pages/TermsPage';
import ContactPage from '@/pages/ContactPage';
import AboutPage from '@/pages/AboutPage';
import AISearchResultsPage from '@/pages/AISearchResultsPage';
import BrowseCategoryPage from '@/pages/BrowseCategoryPage';

// Scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  
  return null;
}

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <ScrollToTop />
        <OrganizationStructuredData />
        <AdminProvider>
          <WizardProvider>
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/guide" element={<HomePage />} />
              <Route path="/platform/:platformId" element={<PlatformDetailPage />} />
              <Route path="/compare" element={<ComparisonPage />} />
              <Route path="/admin" element={<AdminPage />} />
              <Route path="/learn" element={<EducationPage />} />
              <Route path="/blog" element={<BlogPage />} />
              <Route path="/blog/:slug" element={<BlogPostPage />} />
              <Route path="/shared/:shareCode" element={<SharedResultsPage />} />
              <Route path="/suggest" element={<SuggestPage />} />
              {/* Vendor Portal Routes */}
              <Route path="/vendors" element={<VendorInfoPage />} />
              <Route path="/vendors/pricing" element={<VendorPricingPage />} />
              <Route path="/vendors/terms" element={<VendorTermsPage />} />
              <Route path="/vendor" element={<VendorAuthPage />} />
              <Route path="/vendor/login" element={<VendorAuthPage />} />
              <Route path="/vendor/activate" element={<VendorAuthPage />} />
              <Route path="/vendor/reset-password" element={<VendorAuthPage />} />
              <Route path="/vendor/dashboard" element={<VendorDashboardPage />} />
              <Route path="/vendor/edit/:platformId" element={<VendorEditPlatformPage />} />
              {/* Legal & Trust Pages */}
              <Route path="/privacy" element={<PrivacyPage />} />
              <Route path="/terms" element={<TermsPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/about" element={<AboutPage />} />
              {/* AI Search */}
              <Route path="/ai-search" element={<AISearchResultsPage />} />
              {/* Category Browsing */}
              <Route path="/browse/:categoryName" element={<BrowseCategoryPage />} />
            </Routes>
            <Toaster />
          </WizardProvider>
        </AdminProvider>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
